module.exports = __webpack_public_path__ + "static/watchTwo@2x-c80f3e33f808e3fa95e213984508852f.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/wireframing/watchTwo@2x.png
// module id = 2627
// module chunks = 168707334958949